/* global axios */

import ApiClient from '../ApiClient';

class FirecrawlAPI extends ApiClient {
  constructor() {
    super('integrations/firecrawl', { accountScoped: true });
  }

  crawl(body) {
    return axios.post(`${this.url}/crawl`, body);
  }

  status(id) {
    return axios.get(`${this.url}/status`, { params: { id } });
  }
}

export default new FirecrawlAPI();
